module.exports = "query GetChildren($contactId: ID!) {\n  contact(id: $contactId) {\n    children {\n      ...ChildContactFragment\n    }\n  }\n}\n"